import React from 'react'
import GrowthWheelEditorLanding from '../../components/GrowthWheelComponents/GrowthWheelEditorLanding'
import { User } from '../../types/User'

const GrowthWheelEditor = ({ user }: { user: User }) => {
  return <GrowthWheelEditorLanding user={user} />
}

export default GrowthWheelEditor
